<template>
  <div>
    <input-field label="数据地址" v-model="address" :disabled="!editable" :placeholder="note"></input-field>
    <select-field label="数据类型" v-model="type" :list="dataTypes" :disabled="!editable"></select-field>
    <submit-field @click="submit" :disabled="!editable || !isValid">确定</submit-field>
  </div>
</template>

<script>
  import InputField from '@/components/utils/input-field'
  import SelectField from '@/components/utils/select-field'
  import SubmitField from '@/components/utils/submit-field'

  export default {
    props: {
      defaults: {
        required: false,
        default: Object.create(null),
        type: Object
      },
      event: {
        required: false,
        default: 'plc-device-data',
        type: String
      },
      editable: {
        required: false,
        default: true,
        type: Boolean
      }
    },
    data () {
      return {
        address: '',
        type: 'BOOL'
      }
    },
    components: {
      InputField,
      SelectField,
      SubmitField
    },
    computed: {
      dataTypes () {
        let arr = []

        for (let [key, value] of Object.entries(this.$store.state.Config.type)) {
          arr.push({ key, value })
        }

        return arr
      },
      isValid () {
//        return this.address && this.type
        return true
      }
    },
    methods: {
      refresh () {
        this.address = this.defaults.address
        this.type = this.defaults.type
        this.note = this.defaults.note
      },
      submit () {
        this.$emitter.emit(this.event, {
          _id: this.defaults._id,
          address: this.address,
          type: this.type
        })

        this.$emitter.once(`${this.event}Resp`, err => {
          if (!err) {
            this.editable = false
          }
        })
      }
    },
    created () {
      this.refresh()
    },
    watch: {
      defaults () {
        this.refresh()
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/forms/plc-data.vue